<template>
  <section id="rates_container">
    <Styles>
      <b-modal
        v-model="pickerSelectorOpen"
        :width="400"
        scroll="keep"
        class="modal-picker-custom"
      >
        <div class="picker-content">
          <b-clockpicker
            v-model="tempTime"
            inline
            type="is-info"
            placeholder="Seleccione una hora"
            name="tempTime"
          >
            <b-button
              label="Hora actual"
              type="is-info"
              hour-format="24"
              icon-left="clock"
              @click="tempTime = new Date()"
            />
            <b-button
              label="Aceptar"
              type="is-info"
              icon-left="check"
              class="ml-3"
              outlined
              @click="accept()"
            />
          </b-clockpicker>
        </div>
      </b-modal>
      <fieldset class="fieldset">
        <legend>Datos básicos</legend>
        <div class="columns">
          <div class="column">
            <CompanySelector v-model="company" />
          </div>
          <div class="column">
            <b-field label="Código *">
              <b-input
                placeholder="Ingrese un codigo..."
                type="text"
                v-model="code"
                name="code"
                v-validate="'required'"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("code") }}</span>
          </div>
          <div class="column">
            <b-field label="Nombre *">
              <b-input
                placeholder="Ingrese un Nombre..."
                type="text"
                v-model="name"
                name="name"
                v-validate="'required'"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("name") }}</span>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Desde">
              <b-datepicker
                v-model="finalDate"
                placeholder="Seleccione una fecha..."
                icon="calendar-today"
                name="finalDate"
              >
              </b-datepicker>
            </b-field>
            <span class="show-error">{{ errors.first("finalDate") }}</span>
          </div>
          <div class="column">
            <b-field label="Valor Tiquete Perdido *">
              <b-input
                placeholder="Ingrese un valor..."
                type="text"
                v-model="lostTicket"
                v-validate="'required|numeric|min_value:0'"
                name="lostTicket"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("lostTicket") }}</span>
          </div>
          <div class="column">
            <b-field label="Ajuste *">
              <b-input
                placeholder="Ingrese un valor..."
                type="text"
                v-model="adjustment"
                v-validate="'required|numeric|min_value:0'"
                name="adjustment"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("adjustment") }}</span>
          </div>
        </div>
        <div class="columns">
          <div class="column pb-4">
            <b-field label="Descripción Tarifa">
              <b-input
                placeholder="Ingrese una descripción Ej: (Minuto 110)"
                type="textarea"
                name="description"
                v-model="description"
                rows="3"
              />
            </b-field>
          </div>
          <!-- 
          <div class="column">
            <b-field label="Tipo *">
              <b-select
                placeholder="Seleccione un Tipo"
                expanded
                v-model="type"
                name="type"
              >
                <option
                  v-for="option in types"
                  :value="option.id"
                  :key="option.id"
                  :id="option.id"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div> -->
          <!-- <div class="column">
            <b-field label="Valor Tarifa">
              <b-input
                placeholder="Ingrese un valor..."
                type="text"
                v-model="rate"
                v-validate="'numeric'"
                name="rate"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("rate") }}</span>
          </div> -->
        </div>
        <div class="block">
          <b-checkbox v-model="locked" true-value="Y" false-value="N">
            Bloqueado
          </b-checkbox>
          <b-checkbox
            v-model="autoRate"
            true-value="Y"
            false-value="N"
            class="ml-3"
          >
            AutoTarifa
          </b-checkbox>
        </div>
      </fieldset>
      <fieldset class="fieldset">
        <legend>Tiempos de gracia</legend>
        <div class="columns">
          <div class="column is-4">
            <TimeSelector
              label="Hora liquidación *"
              v-model="hourLiquidation"
            />
            <span class="show-error">{{
              errors.first("hourLiquidation")
            }}</span>
          </div>
          <div class="column is-4">
            <TimeSelector label="Salida *" v-model="hourLeave" />
            <span class="show-error">{{ errors.first("hourLeave") }}</span>
          </div>
        </div>
      </fieldset>
      <fieldset class="fieldset">
        <legend>Máximo 24 horas</legend>
        <div class="columns">
          <div class="column is-4">
            <div class="block">
              <b-checkbox v-model="useMax24H" true-value="Y" false-value="N">
                Usar máximo 24 horas
              </b-checkbox>
            </div>
            <div class="block">
              <b-checkbox v-model="cutMidnight" true-value="Y" false-value="N">
                Corte a la media noche
              </b-checkbox>
            </div>
          </div>
          <div class="column is-4">
            <b-field label="Valor">
              <b-input
                placeholder="Ingrese el valor"
                type="number"
                name="valueMax24h"
                v-model="valueMax24h"
              />
            </b-field>
            <span class="show-error">{{ errors.first("valueMax24h") }}</span>
          </div>
        </div>
      </fieldset>
      <!-- <fieldset class="fieldset">
      <legend>Impuestos</legend>
      <div class="columns">
        <div class="column is-4">
          <b-field label="Modo">
            <b-select
              placeholder="Seleccione el modo"
              expanded
              v-model="taxMode"
              name="taxMode"
            >
              <option
                v-for="option in taxModes"
                :value="option.id"
                :key="option.id"
                :id="option.id"
              >
                {{ option.text }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-4 mt-checkbox">
          <b-checkbox v-model="applyTaxes" true-value="Y" false-value="N">
            Aplicar impuestos
          </b-checkbox>
        </div>
      </div>
    </fieldset> -->
      <fieldset class="fieldset">
        <legend>Condiciones Salida</legend>
        <div class="columns mt-1">
          <div class="column">
            <div class="block checkbox-list">
              <b-checkbox v-model="exitOpen" true-value="Y" false-value="N">
                Salida Local - Tarjeta Abierta
              </b-checkbox>
              <b-checkbox v-model="exitClose" true-value="Y" false-value="N">
                Salida Local - Cierra Abierta
              </b-checkbox>
              <b-checkbox
                v-model="exitSubsegments"
                true-value="Y"
                false-value="N"
              >
                Grabar Gracia SubSegmento
              </b-checkbox>
              <b-checkbox v-model="exitSegments" true-value="Y" false-value="N">
                Grabar Gracia Segmento
              </b-checkbox>
              <b-checkbox
                v-model="exitReliquidate"
                true-value="Y"
                false-value="N"
              >
                Reliquidar Sin Iniciar Tiempo
              </b-checkbox>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="fieldset" id="segmentos">
        <legend>Segmentos *</legend>
        <div class="columns">
          <div class="column">
            <vs-button
              @click="addSection()"
              class="ml-2"
              icon="add"
              color="primary"
              type="filled"
            >
              Añadir segmento
            </vs-button>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-table
              focusable
              :data="getSections()"
              :paginated="true"
              :per-page="5"
              :bordered="true"
              :selected.sync="selected"
              :current-page.sync="currentPage"
            >
              <b-table-column field="id" label="Codigo" v-slot="props">
                {{ props.row.id }}
              </b-table-column>
              <b-table-column field="dayFrom" label="Día desde" v-slot="props">
                <b-field>
                  <b-select
                    placeholder="Seleccione el día"
                    expanded
                    v-model="props.row.dayFrom"
                  >
                    <option
                      v-for="option in days"
                      :value="option.id"
                      :key="option.name"
                      :id="option.name"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </b-table-column>
              <b-table-column
                field="hourFrom"
                label="Hora desde"
                v-slot="props"
              >
                <b-field>
                  <b-input
                    placeholder="Seleccione una hora"
                    type="text"
                    v-model="props.row.hourFrom"
                    @focus="
                      openPickerSections('sections', props.row.id, 'hourFrom')
                    "
                  />
                </b-field>
              </b-table-column>
              <b-table-column field="dayTo" label="Día hasta" v-slot="props">
                <b-field>
                  <b-select
                    placeholder="Seleccione el día"
                    expanded
                    v-model="props.row.dayTo"
                    name="dayTo"
                  >
                    <option
                      v-for="option in days"
                      :value="option.id"
                      :key="option.id2"
                      :id="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </b-table-column>
              <b-table-column field="hourTo" label="Horá hasta" v-slot="props">
                <b-field>
                  <b-input
                    placeholder="Seleccione  una hora"
                    type="text"
                    v-model="props.row.hourTo"
                    @focus="
                      openPickerSections('sections', props.row.id, 'hourTo')
                    "
                  />
                </b-field>
              </b-table-column>
              <b-table-column field="date" label="Acciones" v-slot="props">
                <b-field>
                  <b-button
                    type="is-info"
                    title="Seleccionar"
                    @click="getSection(props.row)"
                    style="margin-right: 3px"
                    icon-right="check"
                  />
                  <b-button
                    type="is-danger"
                    title="Eliminar"
                    @click="deleteSection(props.row.code)"
                    icon-right="delete"
                  />
                </b-field>
              </b-table-column>
              <template #bottom-left> </template>
              <template #empty>
                <div class="has-text-centered">Sin registros</div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="columns" v-if="!!selected">
          <div class="column">
            <fieldset class="fieldset">
              <legend>Bloques *</legend>
              <div class="columns">
                <div class="column">
                  <div class="buttons button-group">
                    <b-button @click="addBlocking()" type="is-info">
                      Añadir Bloque
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="columns" v-if="selected != null">
                <div class="column">
                  <b-table
                    :data="getBlocks()"
                    :paginated="true"
                    :per-page="5"
                    :bordered="true"
                    :current-page.sync="currentPageBlockings"
                    class="mb-0"
                  >
                    <b-table-column field="code" label="Código" v-slot="props">
                      <b-field>
                        <b-input
                          placeholder="Código"
                          type="number"
                          v-model="props.row.id"
                          :class="`${props.row.idError ? 'has-error' : ''}`"
                          v-on:input="validLineBlock()"
                        />
                        <span class="show-error" v-if="props.row.idError"
                          >Este Código ya existe</span
                        >
                      </b-field>
                    </b-table-column>
                    <b-table-column field="time" label="Tiempo" v-slot="props">
                      <b-field>
                        <b-input
                          placeholder="02:05"
                          type="text"
                          v-model="props.row.time"
                          v-mask="'##:##'"
                          name="repeat"
                        ></b-input>
                      </b-field>
                    </b-table-column>
                    <b-table-column
                      field="repeat"
                      label="Repetir"
                      v-slot="props"
                    >
                      <b-field>
                        <b-input
                          placeholder="Ingrese un valor..."
                          type="text"
                          v-model="props.row.repeat"
                          name="repeat"
                        ></b-input>
                      </b-field>
                    </b-table-column>
                    <b-table-column
                      field="next"
                      label="Siguiente"
                      v-slot="props"
                    >
                      <b-field>
                        <b-input
                          placeholder="Ingrese un valor..."
                          type="number"
                          v-model="props.row.next"
                          name="next"
                          v-on:input="validLineBlock()"
                          :class="`${props.row.nextError ? 'has-error' : ''}`"
                        ></b-input>
                        <span class="show-error" v-if="props.row.nextError"
                          >No existe un bloque con este código</span
                        >
                      </b-field>
                    </b-table-column>
                    <b-table-column field="value" label="Valor" v-slot="props">
                      <b-field>
                        <b-input
                          placeholder="Ingrese un valor..."
                          type="number"
                          v-model="props.row.value"
                          name="value"
                        ></b-input>
                      </b-field>
                    </b-table-column>
                    <b-table-column
                      field="date"
                      label="Acciones"
                      v-slot="props"
                    >
                      <b-field>
                        <b-button
                          type="is-danger"
                          title="Eliminar"
                          @click="deleteBlocking(props.row.id)"
                          icon-right="delete"
                        />
                      </b-field>
                    </b-table-column>
                    <template #empty>
                      <div class="has-text-centered">Sin registros</div>
                    </template>
                  </b-table>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </fieldset>
      <div class="buttons button-group">
        <vs-button
          @click="save()"
          icon="save"
          color="primary"
          type="filled"
          class="pl-3 pr-3 mr-2"
        >
          Guardar
        </vs-button>

        <vs-button
          @click="cleanForm()"
          icon="close"
          color="dark"
          type="filled"
          class="pl-3 pr-3 mr-2"
          v-if="id != null"
        >
          Limpiar
        </vs-button>
        <vs-button
          @click="deleteCompany()"
          icon="close"
          color="danger"
          type="filled"
          class="pl-3 pr-3"
          v-if="id != null"
        >
          Eliminar
        </vs-button>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </Styles>
  </section>
</template>

<script>
import moment from "moment";
import { ROUTES } from "../../global/api_routes";
import { configToast, TOAST_TYPES } from "../../global/toast";
import DateUtils from "../../global/DateUtils";
import Styles from "./styles";
import TimeSelector from "../../components/Shared/TimeSelector";
import { confirmation, getUrlParameters } from "../../global/utils";
import CompanySelector from "../../components/Shared/CompanySelector";
export default {
  name: "Rates",
  components: { Styles, CompanySelector, TimeSelector },
  data: () => ({
    isLoading: false,
    company: null,
    code: null,
    name: null,
    id: null,
    liquidation: null,
    lostTicket: null,
    description: null,
    locked: "N",
    autoRate: "N",
    finalDate: null,
    value: null,
    adjustment: null,
    rate: null,
    type: null,
    hourLiquidation: null,
    hourLeave: null,
    notAccessible: "N",
    requiresAuth: "N",
    useMax24H: null,
    cutMidnight: null,
    valueMax24h: null,
    exitOpen: "N",
    exitClose: "N",
    exitSubsegments: "N",
    exitSegments: "N",
    exitReliquidate: "N",
    pickerSelectorOpen: false,
    tempTime: null,
    types: [
      { name: "Hora", id: "H" },
      { name: "Fracción", id: "F" },
    ],
    days: [
      { name: "Lunes", id: 1 },
      { name: "Martes", id: 2 },
      { name: "Miercoles", id: 3 },
      { name: "Jueves", id: 4 },
      { name: "Viernes", id: 5 },
      { name: "Sabado", id: 6 },
      { name: "Domingo", id: 7 },
      { name: "Festivo", id: 8 },
      { name: "Especial", id: 9 },
    ],
    companies: [],
    sections: [],
    currentPage: 1,
    currentPageBlockings: 1,
    tableLoading: false,
    selected: null,
    pickerSelection: null,
  }),
  mounted() {
    const rateId = getUrlParameters().code;
    if (rateId) {
      this.getRate(rateId);
    }
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#rates_container");
      return instance.open(message, type);
    },
    getBlocks() {
      return this.selected.blockings.filter((item) => !item.deleted);
    },
    getSections() {
      return this.sections.filter((item) => !item.deleted);
    },
    validLineBlock() {
      this.selected.blockings.forEach((block) => {
        let finded = 0;
        let replyIdBlocks = 0;
        this.selected.blockings.forEach((blockTemp) => {
          if (block.next == blockTemp.id) {
            finded++;
          }
          if (block.id == blockTemp.id) {
            replyIdBlocks++;
          }
        });
        if (finded == 0) {
          block.nextError = true;
        } else {
          block.nextError = false;
        }
        if (replyIdBlocks >= 2) {
          block.idError = true;
        } else {
          block.idError = false;
        }
      });
    },
    openPicker(propertyName) {
      this.pickerSelection = propertyName;
      this.pickerSelectorOpen = true;
    },
    openPickerSections(dataName, sectionId, propertyName) {
      this.pickerSelection = {
        selection: dataName,
        sectionId,
        propertyName,
      };
      this.pickerSelectorOpen = true;
    },
    getRate(code) {
      this.$http
        .get(ROUTES.DASHBOARD.RATES.GET_RATE_BY_CODE, {
          params: {
            code: code,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.fillData(data.info);
            return;
          }
          this.toast("No se ha encontrado la tarifa");
        });
    },
    setPickerSelection() {
      const obj = this.pickerSelection;
      const index = this[obj.selection].findIndex(
        (item) => item.id === obj.sectionId
      );
      this[obj.selection][index][obj.propertyName] = DateUtils.toHour12String({
        date: this.tempTime,
      });
      this[obj.selection][index][`${obj.propertyName}Real`] = this.tempTime;
    },
    accept() {
      this.pickerSelectorOpen = false;
      if (typeof this.pickerSelection === "string") {
        this[this.pickerSelection] = DateUtils.toHour12String({
          date: this.tempTime,
        });
        this[`${this.pickerSelection}Real`] = this.tempTime;
        return;
      }
      if (typeof this.pickerSelection === "object") {
        this.setPickerSelection();
      }
    },
    cleanForm() {
      this.sections = [];
      this.company = null;
      this.code = null;
      this.name = null;
      this.id = null;
      this.description = null;
      this.liquidation = null;
      this.lostTicket = null;
      this.locked = "N";
      this.autoRate = "N";
      this.finalDate = null;
      this.value = null;
      this.adjustment = null;
      this.rate = null;
      this.type = null;
      this.hourLiquidation = null;
      this.hourLeave = null;
      this.notAccessible = "N";
      this.requiresAuth = "N";
      this.isLoading = false;
      this.tableLoading = false;
      this.useMax24H = null;
      this.cutMidnight = null;
      this.valueMax24h = null;
      this.exitOpen = "N";
      this.exitClose = "N";
      this.exitSubsegments = "N";
      this.exitSegments = "N";
      this.exitReliquidate = "N";
      this.selected = null;
      this.$validator.reset();
    },
    getSegmentList() {
      return this.sections.map((item) => ({
        code: item.code,
        initialDay: item.dayTo,
        finalDay: item.dayFrom,
        initialHour: DateUtils.toHourString({ date: item.hourToReal }),
        finalHour: DateUtils.toHourString({ date: item.hourFromReal }),
        status: item.deleted ? "D" : "A",
        blockList: item.blockings.map((block) => ({
          code: block.code,
          id: block.id,
          next: parseInt(block.next),
          time: this.parseTime(block.time),
          repeat: parseInt(block.repeat),
          value: parseFloat(block.value),
          status: block.deleted ? "D" : "A",
        })),
      }));
    },
    fillData(data) {
      this.actualCode = data.code;
      this.adjustment = data.adjustment;
      this.description = data.description;
      this.code = data.id;
      this.name = data.title;
      if (data.fromAt) {
        this.finalDate = DateUtils.parse({ date: data.fromAt }).toDate();
      }
      this.company = data.company.code;
      this.rate = data.tariffValue;
      this.type = data.tariffType;
      this.outGraceTime = data.outGraceTime;
      this.useMax24H = data.useMax24h;
      this.cutMidnight = data.cutMidnight;
      this.valueMax24h = data.valueMax24h;
      this.exitReliquidate = data.exitReliquidate;
      this.hourLiquidation = data.graceLiquidation;
      this.hourLeave = data.graceTime;
      this.exitOpen = data.exitOpen;
      this.exitClose = data.exitClose;
      this.exitSubsegments = data.exitSubsegments;
      this.exitSegments = data.exitSegments;
      this.locked = data.locked;
      this.main = data.autoRate;
      this.lostTicket = data.lostTicket;
      this.sections = data.segmentList.map((item, index) => ({
        code: item.code,
        id: index + 1,
        dayTo: item.initialDay,
        dayFrom: item.finalDay,
        hourTo: DateUtils.toHour12String({
          date: DateUtils.parseHour({ date: item.initialHour }),
        }),
        hourToReal: DateUtils.parseHour({ date: item.initialHour }),
        hourFrom: DateUtils.toHour12String({
          date: DateUtils.parseHour({ date: item.finalHour }),
        }),
        hourFromReal: DateUtils.parseHour({ date: item.finalHour }),
        blockings: item.blockList.map((block) => ({
          code: block.code,
          id: block.id,
          next: block.next,
          time: this.getTimeString(block.time),
          repeat: block.repeat,
          value: block.value,
        })),
      }));
    },
    getObject() {
      return {
        company: {
          code: this.company,
        },
        code: this.actualCode,
        id: this.code,
        title: this.name,
        description: this.description,
        fromAt:
          this.finalDate == null
            ? null
            : DateUtils.toDateString({ date: this.finalDate }),
        lostTicket: this.lostTicket,
        adjustment: this.adjustment,
        tariffValue: this.rate,
        tariffType: this.type,
        graceLiquidation: this.hourLiquidation,
        graceTime: this.hourLeave,
        useMax24h: this.useMax24H,
        cutMidnight: this.cutMidnight,
        valueMax24h: this.valueMax24h,
        exitOpen: this.exitOpen,
        exitClose: this.exitClose,
        exitSubsegments: this.exitSubsegments,
        exitSegments: this.exitSegments,
        exitReliquidate: this.exitReliquidate,
        locked: this.locked,
        main: this.autoRate,
        segmentList: this.getSegmentList(),
      };
    },
    parseTime(time) {
      const parts = time.split(":");
      if (parts.length < 2) {
        return "Tiempo inválido";
      }
      return parseInt(parts[0] * 60) + parseInt(parts[1]);
    },
    getTimeString(time) {
      const hours = Math.floor(time / 60);
      return `${hours}:${time - hours * 60}`;
    },
    save() {
      try {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            console.log(result, this.errors);
            this.toast("Debes completar el formulario", TOAST_TYPES.ERROR);
            return;
          }
          this.isLoading = true;
          const obj = this.getObject();
          const method = this.actualCode ? "put" : "post";
          this.$http[method](ROUTES.DASHBOARD.RATES.SAVE_RATE, obj)
            .then(({ data }) => {
              if (data.code > 0) {
                this.toast(
                  "Se ha guardado correctamente la tarifa",
                  TOAST_TYPES.SUCCESS
                );
                if (!this.actualCode) {
                  this.cleanForm();
                }
                return;
              }
              return this.toast(data.message, TOAST_TYPES.ERROR);
            })
            .catch((erros) => {
              this.toast("Se ha producido un error", TOAST_TYPES.ERROR);
              this.isLoading = false;
            })
            .finally(() => {
              this.isLoading = false;
            });
        });
      } catch (e) {
        console.error(e);
      }
    },
    addSection() {
      const tempData = [
        ...this.sections,
        {
          id: this.sections.length + 1,
          dayFrom: null,
          hourFrom: null,
          dayTo: null,
          hourTo: null,
          blockings: [],
        },
      ];
      this.sections = tempData;
    },
    deleteSection(sectionId) {
      confirmation(this, "¿Deseas elmiminar la sección seleccionada?").then(
        (result) => {
          if (!result) {
            return;
          }
          const index = this.sections.findIndex((sec) => sec.id === sectionId);
          if (index >= 0 && this.sections[index].code) {
            this.sections = this.sections.map((item) => ({
              ...item,
              blockings: item.blockings.map((blockItem) => ({
                ...blockItem,
                deleted: true,
              })),
              deleted: item.id == sectionId,
            }));
            this.selected = null;
            return;
          }
          this.sections.splice(index, 1);
          this.selected = null;
        }
      );
    },
    getSection(section) {
      const newSection = section;
      this.selected = { ...newSection };
      if (!this.selected.blockings) {
        this.selected.blockings = [];
      }
    },
    addBlocking() {
      const index = this.sections.findIndex(
        (sec) => sec.code == this.selected.code
      );
      const newSelected = { ...this.selected };
      const newBlockings = [
        ...newSelected.blockings,
        {
          id: this.selected.blockings.length + 1,
          time: null,
          repeat: null,
          next: null,
          value: null,
        },
      ];
      newSelected.blockings = newBlockings;
      this.selected = newSelected;
      this.sections[index].blockings = this.selected.blockings;
    },
    deleteBlocking(id) {
      confirmation(this, `¿Deseas eliminar el bloque con código ${id}?`).then(
        (result) => {
          if (!result) {
            return;
          }
          const indexBlocking = this.selected.blockings.findIndex(
            (bloc) => bloc.id == id
          );
          if (
            indexBlocking >= 0 &&
            this.selected.blockings[indexBlocking].code
          ) {
            this.selected.blockings = this.selected.blockings.map((item) => ({
              ...item,
              deleted: item.id == id,
            }));
            return;
          }
          this.selected.blockings.splice(indexBlocking, 1);
        }
      );
    },
    getNormalDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
